module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/laptop-a10dc2661ee410fbe1584b71799ab9a6.jpg";